exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row-pointer tbody tr{cursor:pointer}@media print{.pagebreak{page-break-after:always;min-height:1px}body,html{font-size:10pt}}", ""]);

// exports
